function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-11 -58.025)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(11 58.025)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.625,351.154H1.375a1.506,1.506,0,0,1,0-3h19.25a1.506,1.506,0,0,1,0,3Z",
  transform: "translate(0 -333.154)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.625,206.09H1.375a1.506,1.506,0,0,1,0-3h19.25a1.506,1.506,0,0,1,0,3Z",
  transform: "translate(0 -195.59)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.625,61.025H1.375a1.506,1.506,0,0,1,0-3h19.25a1.506,1.506,0,0,1,0,3Z",
  transform: "translate(0 -58.025)"
})));

function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.5587cd9f.svg";
export { ForwardRef as ReactComponent };